import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { FormHelpText } from '../Form';
var InputErrorMessage = styled(FormHelpText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return props.theme.palette.error[500]; });
export default InputErrorMessage;
var templateObject_1;
//# sourceMappingURL=InputErrorMessage.js.map